export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-27.633d2c7d.png";